/**
 * HubSpot forms i18n + datasheet/contact form submit handling
 * Fixes:
 * - fr-fr / fr-ca / uk-ua fallback translation
 * - HubSpot lang=en while page/originalEmbedContext locale is fr-fr
 * - en-de / en-fr / en-ua (English regional markets) must not map to localized form copy
 * - Product page form dropdown values still showing English
 * - Legal consent text inside <span><p>...</p></span>
 * - Corrupted option labels like "Presseeeee..."
 */
(function () {
  var DATASHEET_FORM_ID = '725a53ab-8f7e-4a29-bfad-d9a4205d4a07';
  var CONTACT_SALES_FORM_ID = '0fd74f38-5eac-4ed9-b81d-8a2c8ed752ce';
  var HUBSPOT_I18N_FORM_IDS = [DATASHEET_FORM_ID, CONTACT_SALES_FORM_ID];

  var DATASHEET_EMAIL_API = 'https://shopify-customers-integration-app-kappa.vercel.app/api/datasheet-email';
  var lastSubmissionForEmail = null;

  var TRANSLATIONS = {
    'fr-fr': {
      'First Name': 'Prénom',
      'Last Name': 'Nom de famille',
      'Name': 'Nom de famille',
      'Phone Number': 'Numéro de téléphone',
      'Phone number': 'Numéro de téléphone',
      'Email': 'E-mail',
      'Email Address': 'Adresse e-mail',
      'Company Name': "Nom de l'entreprise",
      'Company name': "Nom de l'entreprise",
      'Country': 'Pays',
      'Regarding': 'Concernant',
      'Message': 'Message',
      'Product Inquiry': 'Demande produit',
      'Careers': 'Carrières',
      'Press': 'Presse',
      'Please Select': 'Veuillez sélectionner',
      'Privacy Policy': 'Politique de confidentialité',
      'SUBMIT': 'SOUMETTRE',
      'Submit': 'Soumettre',
      'Send': 'ENVOYER',
      'Please complete this required field.': 'Veuillez remplir ce champ obligatoire.',

      'ePropelled Inc respects your privacy and will use your information only to manage your account and provide requested products and services.': "ePropelled Inc respecte votre vie privée et n'utilisera vos informations que pour gérer votre compte et fournir les produits et services demandés.",
      'I agree to receive other communications from ePropelled Inc.': "J'accepte de recevoir d'autres communications d'ePropelled Inc.",
      'Subscribe to get the latest industry news from our ePropelled News Portal.': "Abonnez-vous pour recevoir les dernières actualités du secteur via notre portail d'actualités ePropelled.",
      'Subscribe': 'Abonnez-vous',
      ' to get the latest industry news from our ': " pour recevoir les dernières actualités du secteur via notre ",
      'to get the latest industry news from our ': " pour recevoir les dernières actualités du secteur via notre ",
      ' to get the latest industry news from our': " pour recevoir les dernières actualités du secteur via notre ",
      'to get the latest industry news from our': " pour recevoir les dernières actualités du secteur via notre ",
      'ePropelled News Portal': "portail d'actualités ePropelled",
      'For more information on our privacy practices, please review our Privacy Policy.': "Pour plus d'informations sur nos pratiques en matière de confidentialité, veuillez consulter notre politique de confidentialité.",
      'For more information on our privacy practices, please review our ': "Pour plus d'informations sur nos pratiques en matière de confidentialité, veuillez consulter notre ",
      'For more information on our privacy practices, please review our': "Pour plus d'informations sur nos pratiques en matière de confidentialité, veuillez consulter notre ",

      'Thanks for contacting us. One of our representatives will be in touch soon.': 'Merci de nous avoir contactés. Un de nos représentants vous contactera sous peu.',
      'Thanks for downloading our asset. One of our representatives will be in touch soon.': 'Merci pour le téléchargement. Un de nos représentants vous contactera sous peu.',
      'Thanks for contacting us. We\'ll be in touch soon.': 'Merci de nous avoir contactés. Nous vous contacterons sous peu.',
      'Thanks for submitting the form.': 'Merci d\'avoir envoyé le formulaire.',
      'Thank you for submitting the form.': 'Merci d\'avoir envoyé le formulaire.',
      'Thank you, your download will begin shortly!': 'Merci, votre téléchargement commencera sous peu !',
      'Your submission has been received.': 'Votre demande a bien été reçue.',

      'ePropelled Inc respektiert Ihre Privatsphäre und verwendet Ihre Daten ausschließlich zur Verwaltung Ihres Kontos und zur Bereitstellung der angeforderten Produkte und Dienstleistungen.': "ePropelled Inc respecte votre vie privée et n'utilisera vos informations que pour gérer votre compte et fournir les produits et services demandés.",
      'Ich bin damit einverstanden, weitere Mitteilungen von ePropelled Inc. zu erhalten.': "J'accepte de recevoir d'autres communications d'ePropelled Inc.",
      'Abonnieren Sie': 'Abonnez-vous',
      'unseren ': ' à notre ',
      'ePropelled News-Portal': "portail d'actualités ePropelled",
      ', um die neuesten Branchennachrichten zu erhalten.': ' pour recevoir les dernières actualités du secteur.',
      'Weitere Informationen zu unseren Datenschutzpraktiken finden Sie in unserer ': "Pour plus d'informations sur nos pratiques en matière de confidentialité, veuillez consulter notre ",
      'Datenschutzerklärung': 'politique de confidentialité'
    },

    'fr-ca': {
      'First Name': 'Prénom',
      'Last Name': 'Nom de famille',
      'Name': 'Nom de famille',
      'Phone Number': 'Numéro de téléphone',
      'Phone number': 'Numéro de téléphone',
      'Email': 'Courriel',
      'Email Address': 'Adresse courriel',
      'Company Name': "Nom de l'entreprise",
      'Company name': "Nom de l'entreprise",
      'Country': 'Pays',
      'Regarding': 'Concernant',
      'Message': 'Message',
      'Product Inquiry': 'Demande produit',
      'Careers': 'Carrières',
      'Press': 'Presse',
      'Please Select': 'Veuillez faire un choix',
      'Privacy Policy': 'Politique de confidentialité',
      'SUBMIT': 'SOUMETTRE',
      'Submit': 'Soumettre',
      'Send': 'ENVOYER',
      'Please complete this required field.': 'Veuillez remplir ce champ obligatoire.',

      'ePropelled Inc respects your privacy and will use your information only to manage your account and provide requested products and services.': "ePropelled Inc respecte votre vie privée et n'utilisera vos informations que pour gérer votre compte et fournir les produits et services demandés.",
      'I agree to receive other communications from ePropelled Inc.': "J'accepte de recevoir d'autres communications d'ePropelled Inc.",
      'Subscribe to get the latest industry news from our ePropelled News Portal.': "Abonnez-vous pour recevoir les dernières actualités du secteur via notre portail d'actualités ePropelled.",
      'Subscribe': 'Abonnez-vous',
      ' to get the latest industry news from our ': " pour recevoir les dernières actualités du secteur via notre ",
      'to get the latest industry news from our ': " pour recevoir les dernières actualités du secteur via notre ",
      ' to get the latest industry news from our': " pour recevoir les dernières actualités du secteur via notre ",
      'to get the latest industry news from our': " pour recevoir les dernières actualités du secteur via notre ",
      'ePropelled News Portal': "portail d'actualités ePropelled",
      'For more information on our privacy practices, please review our Privacy Policy.': "Pour plus d'informations sur nos pratiques en matière de confidentialité, veuillez consulter notre politique de confidentialité.",
      'For more information on our privacy practices, please review our ': "Pour plus d'informations sur nos pratiques en matière de confidentialité, veuillez consulter notre ",
      'For more information on our privacy practices, please review our': "Pour plus d'informations sur nos pratiques en matière de confidentialité, veuillez consulter notre ",

      'Thanks for contacting us. One of our representatives will be in touch soon.': 'Merci de nous avoir contactés. Un de nos représentants vous contactera sous peu.',
      'Thanks for downloading our asset. One of our representatives will be in touch soon.': 'Merci pour le téléchargement. Un de nos représentants vous contactera sous peu.',
      'Thanks for contacting us. We\'ll be in touch soon.': 'Merci de nous avoir contactés. Nous vous contacterons sous peu.',
      'Thanks for submitting the form.': 'Merci d\'avoir envoyé le formulaire.',
      'Thank you for submitting the form.': 'Merci d\'avoir envoyé le formulaire.',
      'Thank you, your download will begin shortly!': 'Merci, votre téléchargement commencera sous peu !',
      'Your submission has been received.': 'Votre demande a bien été reçue.',

      'ePropelled Inc respektiert Ihre Privatsphäre und verwendet Ihre Daten ausschließlich zur Verwaltung Ihres Kontos und zur Bereitstellung der angeforderten Produkte und Dienstleistungen.': "ePropelled Inc respecte votre vie privée et n'utilisera vos informations que pour gérer votre compte et fournir les produits et services demandés.",
      'Ich bin damit einverstanden, weitere Mitteilungen von ePropelled Inc. zu erhalten.': "J'accepte de recevoir d'autres communications d'ePropelled Inc.",
      'Abonnieren Sie': 'Abonnez-vous',
      'unseren ': ' à notre ',
      'ePropelled News-Portal': "portail d'actualités ePropelled",
      ', um die neuesten Branchennachrichten zu erhalten.': ' pour recevoir les dernières actualités du secteur.',
      'Weitere Informationen zu unseren Datenschutzpraktiken finden Sie in unserer ': "Pour plus d'informations sur nos pratiques en matière de confidentialité, veuillez consulter notre ",
      'Datenschutzerklärung': 'politique de confidentialité'
    },

    'uk-ua': {
      'First Name': "Ім'я",
      'Last Name': 'Фамілія',
      'Phone Number': 'Номер мобільного телефону',
      'Phone number': 'Номер мобільного телефону',
      'Email': 'Електронна пошта',
      'Email Address': 'Адреса електронної пошти',
      'Company Name': 'Імʼя вашої компанії',
      'Company name': 'Імʼя вашої компанії',
      'Country': 'Країна',
      'Regarding': 'З приводу',
      'Message': 'Повідомлення',
      'Product Inquiry': 'Запитання щодо продукту',
      'Careers': "Карʼєра",
      'Press': 'Преса',
      'Please Select': 'Будь ласка, оберіть',
      'Privacy Policy': 'Політику конфіденційності',
      'SUBMIT': 'ВІДПРАВИТИ',
      'Submit': 'Відправити',
      'Send': 'НАДІСЛАТИ',
      'Please complete this required field.': 'Будь ласка, заповніть це обов’язкове поле.',

      'ePropelled Inc respects your privacy and will use your information only to manage your account and provide requested products and services.': 'Компанія ePropelled Inc поважає вашу конфіденційність і використовуватиме ваші дані лише для керування обліковим записом та надання замовлених продуктів і послуг.',
      'I agree to receive other communications from ePropelled Inc.': 'Я погоджуюся отримувати інші комунікації від ePropelled Inc.',
      'Subscribe to get the latest industry news from our ePropelled News Portal.': 'Підпишіться, щоб отримувати останні галузеві новини на нашому порталі новин ePropelled.',
      'Subscribe': 'Підписатися',
      ' to get the latest industry news from our ': ' щоб отримувати останні галузеві новини на нашому ',
      'to get the latest industry news from our ': 'щоб отримувати останні галузеві новини на нашому ',
      ' to get the latest industry news from our': ' щоб отримувати останні галузеві новини на нашому ',
      'to get the latest industry news from our': ' щоб отримувати останні галузеві новини на нашому ',
      'ePropelled News Portal': 'портал новин ePropelled',
      'For more information on our privacy practices, please review our Privacy Policy.': 'Щоб дізнатися більше про нашу політику конфіденційності, перегляньте нашу політику конфіденційності.',
      'For more information on our privacy practices, please review our ': 'Щоб дізнатися більше про нашу політику конфіденційності, перегляньте нашу ',
      'For more information on our privacy practices, please review our': 'Щоб дізнатися більше про нашу політику конфіденційності, перегляньте нашу ',

      'Thanks for contacting us. One of our representatives will be in touch soon.': 'Дякуємо, що зв’язалися з нами. Один із наших представників незабаром з вами зв’яжеться.',
      'Thanks for downloading our asset. One of our representatives will be in touch soon.': 'Дякуємо за завантаження. Один із наших представників незабаром з вами зв’яжеться.',
      'Thanks for contacting us. We\'ll be in touch soon.': 'Дякуємо, що зв’язалися з нами. Ми незабаром з вами зв’яжемося.',
      'Thanks for submitting the form.': 'Дякуємо за надсилання форми.',
      'Thank you for submitting the form.': 'Дякуємо за надсилання форми.',
      'Thank you, your download will begin shortly!': 'Дякуємо, ваше завантаження незабаром почнеться!',
      'Your submission has been received.': 'Вашу заявку отримано.',

      'ePropelled Inc respektiert Ihre Privatsphäre und verwendet Ihre Daten ausschließlich zur Verwaltung Ihres Kontos und zur Bereitstellung der angeforderten Produkte und Dienstleistungen.': 'Компанія ePropelled Inc поважає вашу конфіденційність і використовуватиме ваші дані лише для керування обліковим записом та надання замовлених продуктів і послуг.',
      'Ich bin damit einverstanden, weitere Mitteilungen von ePropelled Inc. zu erhalten.': 'Я погоджуюся отримувати інші комунікації від ePropelled Inc.',
      'Abonnieren Sie': 'Підпишіться',
      'unseren ': ' на наш ',
      'ePropelled News-Portal': 'портал новин ePropelled',
      ', um die neuesten Branchennachrichten zu erhalten.': ', щоб отримувати останні галузеві новини.',
      'Weitere Informationen zu unseren Datenschutzpraktiken finden Sie in unserer ': 'Щоб дізнатися більше про нашу політику конфіденційності, перегляньте нашу ',
      'Datenschutzerklärung': 'політику конфіденційності'
    },

    'de-de': {
      'First Name': 'Vorname',
      'Last Name': 'Nachname',
      'Phone Number': 'Telefonnummer',
      'Phone number': 'Telefonnummer',
      'Email': 'E-Mail-Adresse',
      'Email Address': 'E-Mail-Adresse',
      'Company Name': 'Firmenname',
      'Company name': 'Firmenname',
      'Country': 'Land',
      'Regarding': 'Betreff',
      'Message': 'Nachricht',
      'Product Inquiry': 'Produktanfrage',
      'Careers': 'Karriere',
      'Press': 'Presse',
      'Please Select': 'Bitte auswählen',
      'Privacy Policy': 'Datenschutzerklärung',
      'SUBMIT': 'ABSENDEN',
      'Submit': 'Absenden',
      'Send': 'SENDEN',
      'Please complete this required field.': 'Bitte füllen Sie dieses Pflichtfeld aus.',

      'ePropelled Inc respects your privacy and will use your information only to manage your account and provide requested products and services.': 'ePropelled Inc respektiert Ihre Privatsphäre und verwendet Ihre Daten nur zur Verwaltung Ihres Kontos und zur Bereitstellung der angeforderten Produkte und Dienstleistungen.',
      'I agree to receive other communications from ePropelled Inc.': 'Ich bin damit einverstanden, weitere Mitteilungen von ePropelled Inc. zu erhalten.',
      'Subscribe to get the latest industry news from our ePropelled News Portal.': 'Abonnieren Sie die neuesten Branchennachrichten über unser ePropelled-Nachrichtenportal.',
      'Subscribe': 'Abonnieren',
      ' to get the latest industry news from our ': ' Sie die neuesten Branchennachrichten über unser ',
      'to get the latest industry news from our ': 'Sie die neuesten Branchennachrichten über unser ',
      ' to get the latest industry news from our': ' Sie die neuesten Branchennachrichten über unser ',
      'to get the latest industry news from our': ' Sie die neuesten Branchennachrichten über unser ',
      'ePropelled News Portal': 'ePropelled-Nachrichtenportal',
      'ePropelled News Portal.': 'ePropelled-Nachrichtenportal.',
      'ePropelled-News-Portal': 'ePropelled-Nachrichtenportal',
      'ePropelled-News-Portal.': 'ePropelled-Nachrichtenportal.',
      'ePropelled News-Portal': 'ePropelled-Nachrichtenportal',
      'For more information on our privacy practices, please review our Privacy Policy.': 'Weitere Informationen zu unseren Datenschutzpraktiken finden Sie in unserer Datenschutzerklärung.',
      'For more information on our privacy practices, please review our ': 'Weitere Informationen zu unseren Datenschutzpraktiken finden Sie in unserer ',
      'For more information on our privacy practices, please review our': 'Weitere Informationen zu unseren Datenschutzpraktiken finden Sie in unserer ',

      'Thanks for contacting us. One of our representatives will be in touch soon.': 'Vielen Dank für Ihre Kontaktaufnahme. Einer unserer Vertreter wird sich in Kürze bei Ihnen melden.',
      'Thanks for downloading our asset. One of our representatives will be in touch soon.': 'Vielen Dank für den Download. Einer unserer Vertreter wird sich in Kürze bei Ihnen melden.',
      'Thanks for contacting us. We\'ll be in touch soon.': 'Vielen Dank für Ihre Kontaktaufnahme. Wir melden uns in Kürze bei Ihnen.',
      'Thanks for submitting the form.': 'Vielen Dank für die Übermittlung des Formulars.',
      'Thank you for submitting the form.': 'Vielen Dank für die Übermittlung des Formulars.',
      'Thank you, your download will begin shortly!': 'Vielen Dank, Ihr Download beginnt in Kürze!',
      'Your submission has been received.': 'Ihre Anfrage wurde empfangen.'
    }
  };

  var OPTION_LABEL_FIXES = {
    'fr-fr': {
      'Product Inquiry': 'Demande produit',
      'Careers': 'Carrières',
      'Press': 'Presse',

      'Antigua and Barbuda': 'Antigua-et-Barbuda',
      'Bosnia and Herzegovina': 'Bosnie-Herzégovine',
      'Congo (Congo-Brazzaville)': 'Congo-Brazzaville',
      'Czech Republic': 'République tchèque',
      'Democratic Republic of the Congo': 'République démocratique du Congo',
      'Guyana': 'Guyana',
      'Liberia': 'Libéria',
      'Palestine State': 'État de Palestine',
      'Saint Kitts and Nevis': 'Saint-Christophe-et-Niévès',
      'Saint Lucia': 'Sainte-Lucie',
      'Saint Vincent and the Grenadines': 'Saint-Vincent-et-les-Grenadines',
      'Sao Tome and Principe': 'Sao Tomé-et-Principe',
      'Sierra Leone': 'Sierra Leone',
      'South Korea': 'Corée du Sud',
      'Trinidad and Tobago': 'Trinité-et-Tobago',
      'Turkey': 'Turquie'
    },

    'fr-ca': {
      'Product Inquiry': 'Demande produit',
      'Careers': 'Carrières',
      'Press': 'Presse',

      'Antigua and Barbuda': 'Antigua-et-Barbuda',
      'Bosnia and Herzegovina': 'Bosnie-Herzégovine',
      'Congo (Congo-Brazzaville)': 'Congo-Brazzaville',
      'Czech Republic': 'République tchèque',
      'Democratic Republic of the Congo': 'République démocratique du Congo',
      'Guyana': 'Guyana',
      'Liberia': 'Libéria',
      'Palestine State': 'État de Palestine',
      'Saint Kitts and Nevis': 'Saint-Christophe-et-Niévès',
      'Saint Lucia': 'Sainte-Lucie',
      'Saint Vincent and the Grenadines': 'Saint-Vincent-et-les-Grenadines',
      'Sao Tome and Principe': 'Sao Tomé-et-Principe',
      'Sierra Leone': 'Sierra Leone',
      'South Korea': 'Corée du Sud',
      'Trinidad and Tobago': 'Trinité-et-Tobago',
      'Turkey': 'Turquie'
    },

    'uk-ua': {
      'Product Inquiry': 'Запит щодо продукту',
      'Careers': "Кар'єра",
      'Press': 'Преса',

      'Antigua and Barbuda': 'Антигуа і Барбуда',
      'Bosnia and Herzegovina': 'Боснія і Герцеговина',
      'Congo (Congo-Brazzaville)': 'Конго-Браззавіль',
      'Czech Republic': 'Чехія',
      'Democratic Republic of the Congo': 'Демократична Республіка Конго',
      'Guyana': 'Гаяна',
      'Liberia': 'Ліберія',
      'Palestine State': 'Держава Палестина',
      'Saint Kitts and Nevis': 'Сент-Кітс і Невіс',
      'Saint Lucia': 'Сент-Люсія',
      'Saint Vincent and the Grenadines': 'Сент-Вінсент і Гренадини',
      'Sao Tome and Principe': 'Сан-Томе і Принсіпі',
      'Sierra Leone': 'Сьєрра-Леоне',
      'South Korea': 'Південна Корея',
      'Trinidad and Tobago': 'Тринідад і Тобаго',
      'Turkey': 'Туреччина'
    },

    'de-de': {
      'Product Inquiry': 'Produktanfrage',
      'Careers': 'Karriere',
      'Press': 'Presse'
    }
  };

  var TRANSLATION_PAIRS = {};

  Object.keys(TRANSLATIONS).forEach(function (loc) {
    var dict = TRANSLATIONS[loc];
    var keys = Object.keys(dict);

    keys.sort(function (a, b) {
      return b.length - a.length;
    });

    TRANSLATION_PAIRS[loc] = keys.map(function (key) {
      return [key, dict[key]];
    });
  });

  function normalizeLocaleToken(value) {
    if (!value || typeof value !== 'string') return '';

    return String(value)
      .replace(/[\u2010\u2011\u2012\u2013\u2014\u2212]/g, '-')
      .replace(/_/g, '-')
      .toLowerCase()
      .trim();
  }

  function normalizeFormId(formId) {
    return String(formId || '').toLowerCase().replace(/-/g, '');
  }

  var ENGLISH_MARKET_LOCALES = ['en-de', 'en-fr', 'en-ua'];

  function getEnglishMarketLocale(raw) {
    var value = raw;

    if (!value || typeof value !== 'string') {
      value = (window.location && window.location.pathname) || '';

      if (window.location && window.location.href) {
        value = value + ' ' + window.location.href;
      }
    }

    value = normalizeLocaleToken(value);

    for (var i = 0; i < ENGLISH_MARKET_LOCALES.length; i++) {
      var market = ENGLISH_MARKET_LOCALES[i];

      if (value === market || new RegExp('(^|[\\/?&=#])' + market + '(\\/|$|[?&#=])', 'i').test(value)) {
        return market;
      }
    }

    return null;
  }

  function resolveTranslationKey(raw) {
    if (!raw || typeof raw !== 'string') return null;

    var value = normalizeLocaleToken(raw);

    if (!value) return null;

    if (getEnglishMarketLocale(value)) return null;

    if (TRANSLATIONS[value]) return value;

    if (/(^|[\/?&=#])fr-fr(\/|$|[?&#=])/i.test(value)) return 'fr-fr';
    if (/(^|[\/?&=#])fr-ca(\/|$|[?&#=])/i.test(value)) return 'fr-ca';
    if (/(^|[\/?&=#])de-de(\/|$|[?&#=])/i.test(value)) return 'de-de';
    if (/(^|[\/?&=#])uk-ua(\/|$|[?&#=])/i.test(value)) return 'uk-ua';

    if (/^[a-z]{2}-fr$/i.test(value)) {
      if (value.indexOf('en-') === 0) return null;
      return 'fr-fr';
    }
    if (/^[a-z]{2}-de$/i.test(value)) {
      if (value.indexOf('en-') === 0) return null;
      return 'de-de';
    }
    if (/^[a-z]{2}-ua$/i.test(value)) {
      if (value.indexOf('en-') === 0) return null;
      return 'uk-ua';
    }

    if (/^fr-/.test(value) && value !== 'fr-ca') return 'fr-fr';

    if (value === 'fr') return 'fr-fr';
    if (value === 'de') return 'de-de';
    if (value === 'uk' || value === 'ua') return 'uk-ua';

    return null;
  }

  function localeFromPath(pathname) {
    if (!pathname) return null;

    var path = String(pathname);
    var parts = path.split('/').filter(Boolean);

    for (var i = 0; i < parts.length; i++) {
      var resolved = resolveTranslationKey(parts[i]);

      if (resolved) return resolved;
    }

    return resolveTranslationKey(path);
  }

  function localeFromUrl(url) {
    if (!url || typeof url !== 'string') return null;

    var direct = resolveTranslationKey(url);

    if (direct) return direct;

    try {
      var parsed = new URL(url, window.location.origin);
      return localeFromPath(parsed.pathname);
    } catch (e) {
      return null;
    }
  }

  function localeFromCanonical() {
    var link = document.querySelector('link[rel="canonical"]');

    if (!link || !link.href) return null;

    return localeFromUrl(link.href);
  }

  function localeFromShopifyRootUrl() {
    try {
      var rootUrl = window.theme && window.theme.routes && window.theme.routes.root_url;

      if (!rootUrl || typeof rootUrl !== 'string') return null;

      return localeFromUrl(rootUrl);
    } catch (e) {
      return null;
    }
  }

  function localeFromShopifyCountry() {
    var country = window.__EP_SHOPIFY_MARKET_COUNTRY;

    if (!country || typeof country !== 'string') return null;

    country = normalizeLocaleToken(country);

    var forcedPair = normalizeLocaleToken(window.__EP_HUBSPOT_I18N_LOCALE || '');

    if (country === 'fr' || country === 'france') return 'fr-fr';
    if (country === 'de' || country === 'germany') return 'de-de';
    if (country === 'ua' || country === 'ukraine') return 'uk-ua';

    if (country === 'ca') {
      if (forcedPair === 'fr-ca' || /^fr-/.test(forcedPair)) return 'fr-ca';
    }

    return null;
  }

  function localeFromBodyClass() {
    var body = document.body;

    if (!body || !body.className) return null;

    var className = String(body.className);
    var match = className.match(/\b([a-z]{2})-market\b/i);

    if (match) return resolveTranslationKey(match[1]);

    match = className.match(/\btemplate-([a-z]{2})\b/i);

    if (match) return resolveTranslationKey(match[1]);

    return null;
  }

  function localeFromHubspotContextInDocument(doc) {
    try {
      if (!doc || !doc.querySelectorAll) return null;

      var inputs = doc.querySelectorAll('input[name="hs_context"]');

      for (var i = 0; i < inputs.length; i++) {
        var raw = inputs[i].value || '';

        if (!raw) continue;

        var ctx = JSON.parse(raw);

        var candidates = [
          ctx.pageUrl,
          ctx.referrer,
          ctx.locale,
          ctx.lang
        ];

        if (ctx.originalEmbedContext) {
          candidates.push(ctx.originalEmbedContext.locale);
          candidates.push(ctx.originalEmbedContext.language);
          candidates.push(ctx.originalEmbedContext.pageUrl);
          candidates.push(ctx.originalEmbedContext.referrer);
        }

        for (var j = 0; j < candidates.length; j++) {
          var candidate = candidates[j];

          if (!candidate || typeof candidate !== 'string') continue;

          var resolved = localeFromUrl(candidate) || resolveTranslationKey(candidate);

          if (resolved) return resolved;
        }
      }
    } catch (e) {}

    return null;
  }

  function localeFromHubspotContextEverywhere() {
    var locale = localeFromHubspotContextInDocument(document);

    if (locale) return locale;

    var iframes = document.querySelectorAll('iframe');

    for (var i = 0; i < iframes.length; i++) {
      try {
        var doc = iframes[i].contentDocument ||
          (iframes[i].contentWindow && iframes[i].contentWindow.document);

        locale = localeFromHubspotContextInDocument(doc);

        if (locale) return locale;
      } catch (e) {}
    }

    return null;
  }

  function getCurrentFormLocale() {
    if (getEnglishMarketLocale()) return null;

    var forced = window.__EP_HUBSPOT_I18N_LOCALE;

    if (forced && typeof forced === 'string') {
      var forcedLocale = resolveTranslationKey(forced);

      if (forcedLocale) return forcedLocale;
    }

    var fromPath = localeFromPath(window.location.pathname || '');

    if (fromPath) return fromPath;

    var fromHref = localeFromUrl(window.location.href || '');

    if (fromHref) return fromHref;

    var fromHsContext = localeFromHubspotContextEverywhere();

    if (fromHsContext) return fromHsContext;

    var fromRoot = localeFromShopifyRootUrl();

    if (fromRoot) return fromRoot;

    var fromCanonical = localeFromCanonical();

    if (fromCanonical) return fromCanonical;

    var htmlLang = document.documentElement && document.documentElement.lang;

    if (htmlLang) {
      var fromHtmlLang = resolveTranslationKey(htmlLang);

      if (fromHtmlLang) return fromHtmlLang;
    }

    if (window.Shopify && window.Shopify.locale) {
      var fromShopifyLocale = resolveTranslationKey(String(window.Shopify.locale));

      if (fromShopifyLocale) return fromShopifyLocale;
    }

    var fromCountry = localeFromShopifyCountry();

    if (fromCountry) return fromCountry;

    var fromBody = localeFromBodyClass();

    if (fromBody) return fromBody;

    return null;
  }

  function formSelector() {
    return HUBSPOT_I18N_FORM_IDS.map(function (id) {
      return 'form[data-form-id="' + id + '"]';
    }).join(', ');
  }

  function isTargetHubspotForm(form) {
    if (!form || !form.getAttribute) return false;

    var formId = normalizeFormId(form.getAttribute('data-form-id') || '');

    if (!formId) return false;

    for (var i = 0; i < HUBSPOT_I18N_FORM_IDS.length; i++) {
      if (formId === normalizeFormId(HUBSPOT_I18N_FORM_IDS[i])) return true;
    }

    return false;
  }

  function getFormRoot(el) {
    if (!el || el.nodeType !== 1) return null;

    if (el.matches && isTargetHubspotForm(el)) return el;

    if (el.querySelector) {
      var found = el.querySelector(formSelector());

      if (found) return found;
    }

    return null;
  }

  function resolveHubspotI18nRoot(el) {
    if (!el || el.nodeType !== 1) return null;

    if (el.closest) {
      var embed = el.closest('.hbspt-form, [data-hs-forms-root="true"]');

      if (embed) return embed;
    }

    if (el.matches && el.matches('.hbspt-form, [data-hs-forms-root="true"]')) {
      return el;
    }

    return el;
  }

  function collectHubspotI18nTargets() {
    var forms = getAllHubspotForms();
    var targets = [];
    var seen = [];

    for (var i = 0; i < forms.length; i++) {
      var root = resolveHubspotI18nRoot(forms[i]);

      if (!root || seen.indexOf(root) !== -1) continue;

      seen.push(root);
      targets.push(root);
    }

    return targets;
  }

  function normalizeHubspotArg(arg) {
    if (!arg) return null;

    if (arg.nodeType === 1) return getFormRoot(arg);

    if (arg.jquery && arg.length) return getFormRoot(arg[0]);

    if (typeof arg.get === 'function' && arg.get(0)) return getFormRoot(arg.get(0));

    return null;
  }

  function collectFormsFromShadowRoots(root, bucket) {
    if (!root || !root.querySelectorAll) return;

    var all = root.querySelectorAll('*');

    for (var i = 0; i < all.length; i++) {
      var el = all[i];

      if (!el.shadowRoot) continue;

      var forms = el.shadowRoot.querySelectorAll(formSelector());

      for (var j = 0; j < forms.length; j++) {
        bucket.push(forms[j]);
      }

      collectFormsFromShadowRoots(el.shadowRoot, bucket);
    }
  }

  function getAllHubspotForms() {
    var forms = [];
    var lightForms = document.querySelectorAll(formSelector());

    for (var i = 0; i < lightForms.length; i++) {
      forms.push(lightForms[i]);
    }

    collectFormsFromShadowRoots(document.documentElement, forms);

    var iframes = document.querySelectorAll('iframe');

    for (i = 0; i < iframes.length; i++) {
      try {
        var doc = iframes[i].contentDocument ||
          (iframes[i].contentWindow && iframes[i].contentWindow.document);

        if (!doc || !doc.querySelectorAll) continue;

        var iframeForms = doc.querySelectorAll(formSelector());

        for (var j = 0; j < iframeForms.length; j++) {
          forms.push(iframeForms[j]);
        }
      } catch (e) {}
    }

    return forms;
  }

  var SKIP_PARENT_TAGS = {
    SCRIPT: true,
    STYLE: true,
    NOSCRIPT: true
  };

  function normalizeTranslatableText(text) {
    return splitTranslatableText(text).core;
  }

  function splitTranslatableText(text) {
    var value = String(text || '');
    var leading = (value.match(/^\s*/) || [''])[0];
    var trailing = (value.match(/\s*$/) || [''])[0];
    var core = value
      .replace(/\u00a0/g, ' ')
      .replace(/[\u2010\u2011\u2012\u2013\u2014\u2212]/g, '-')
      .replace(/\s+/g, ' ')
      .trim();

    return {
      leading: leading,
      core: core,
      trailing: trailing
    };
  }

  function replaceByPairsCore(text, pairs, exactOnly) {
    if (!text || !pairs || !pairs.length) return text;

    var output = text;

    for (var i = 0; i < pairs.length; i++) {
      var from = pairs[i][0];
      var to = pairs[i][1];

      if (exactOnly) {
        if (output === from || output.toLowerCase() === from.toLowerCase()) {
          return to;
        }
      } else if (output.indexOf(from) !== -1) {
        // Skip when text is already translated (e.g. Press -> Presse, then Presse matched again).
        if (to.indexOf(from) === 0 && output.indexOf(to) !== -1) {
          continue;
        }

        output = output.split(from).join(to);
      }
    }

    return output;
  }

  function replaceByPairs(text, pairs, exactOnly) {
    return replaceByPairsCore(normalizeTranslatableText(text), pairs, exactOnly);
  }

  function needsLeadingSpaceBeforeText(text) {
    return !!text && text.charAt(0) !== ' ' && text.charAt(0) !== '\u00a0';
  }

  function needsTrailingSpaceAfterText(text) {
    return !!text && text.charAt(text.length - 1) !== ' ' && text.charAt(text.length - 1) !== '\u00a0';
  }

  function fixLinkAdjacentSpacing(root) {
    if (!root || !root.querySelectorAll) return;

    var containers = root.querySelectorAll(
      '.hs-richtext, .legal-consent-container, .hs-legal-consent, label span, label'
    );
    var ci;

    function fixNode(node) {
      if (!node || !node.childNodes) return;

      for (var i = 0; i < node.childNodes.length; i++) {
        var child = node.childNodes[i];

        if (child.nodeType === 3) {
          var value = child.nodeValue || '';
          var prev = child.previousSibling;
          var next = child.nextSibling;

          if (prev && prev.nodeType === 1 && prev.tagName === 'A' && needsLeadingSpaceBeforeText(value)) {
            value = ' ' + value;
          }

          if (next && next.nodeType === 1 && next.tagName === 'A' && needsTrailingSpaceAfterText(value)) {
            value = value + ' ';
          }

          if (value !== child.nodeValue) {
            child.nodeValue = value;
          }
        } else if (child.nodeType === 1 && !SKIP_PARENT_TAGS[child.tagName]) {
          fixNode(child);
        }
      }
    }

    for (ci = 0; ci < containers.length; ci++) {
      fixNode(containers[ci]);
    }

    fixNode(root);
  }

  function translateAnchorElement(anchor, pairs) {
    if (!anchor || !pairs || !pairs.length) return;

    var text = normalizeTranslatableText(anchor.textContent || '');

    if (!text) return;

    var output = replaceByPairs(text, pairs, true);

    if (output === text) {
      output = replaceByPairs(text, pairs, false);
    }

    if (output !== text) {
      anchor.textContent = output;
    }
  }

  function translateFormAnchors(root, pairs) {
    if (!root || !root.querySelectorAll || !pairs || !pairs.length) return;

    var anchors = root.querySelectorAll(
      'label a[href], .hs-richtext a[href], .hs-legal-consent a[href], .legal-consent-container a[href], a[href*="news.epropelled.com"], a[href*="/policies/privacy-policy"]'
    );

    for (var i = 0; i < anchors.length; i++) {
      translateAnchorElement(anchors[i], pairs);
    }
  }

  function translateRichTextBlocks(root, pairs) {
    if (!root || !root.querySelectorAll || !pairs || !pairs.length) return;

    var blocks = root.querySelectorAll(
      '.hs-richtext, .legal-consent-container .hs-richtext, .hs-legal-consent .hs-richtext'
    );

    for (var i = 0; i < blocks.length; i++) {
      translateTextNodes(blocks[i], pairs);
      translateFormAnchors(blocks[i], pairs);
      fixLinkAdjacentSpacing(blocks[i]);
    }
  }

  function translateTextNodes(root, pairs) {
    if (!root || !pairs || !pairs.length) return;

    var ownerDoc = root.ownerDocument || document;
    var walker = ownerDoc.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var nodes = [];
    var node;

    while ((node = walker.nextNode())) {
      nodes.push(node);
    }

    for (var i = 0; i < nodes.length; i++) {
      var textNode = nodes[i];
      var parent = textNode.parentElement;

      if (!parent || SKIP_PARENT_TAGS[parent.tagName]) continue;

      if (parent.tagName === 'OPTION' || parent.tagName === 'OPTGROUP') continue;

      var raw = textNode.nodeValue;
      var parts = splitTranslatableText(raw);

      if (!parts.core) continue;

      var output = replaceByPairsCore(parts.core, pairs, false);

      if (output !== parts.core) {
        textNode.nodeValue = parts.leading + output + parts.trailing;
      }
    }
  }

  function translateLabelSpans(root, pairs) {
    if (!root || !root.querySelectorAll) return;

    var spans = root.querySelectorAll(
      '.hs-form-field label > span:not(.hs-form-required), label > span:not(.hs-form-required)'
    );

    for (var i = 0; i < spans.length; i++) {
      var span = spans[i];
      var text = (span.textContent || '').replace(/\s+/g, ' ').trim();

      if (!text) continue;

      var output = replaceByPairs(text, pairs, true);

      var p = span.querySelector ? span.querySelector('p') : null;

      if (output !== text) {
        if (p) {
          p.textContent = output;
        } else if (!span.querySelector || !span.querySelector('a, ul, ol')) {
          span.textContent = output;
        }
      } else if (p && p.querySelector && p.querySelector('a')) {
        translateTextNodes(p, pairs);
        translateFormAnchors(p, pairs);
      }
    }
  }

  function translateInputsAndButtons(root, pairs) {
    if (!root || !root.querySelectorAll) return;

    var fields = root.querySelectorAll('[placeholder], [title], input[type="submit"], input[type="button"]');

    for (var i = 0; i < fields.length; i++) {
      var el = fields[i];

      ['placeholder', 'title', 'value'].forEach(function (attr) {
        var current = el.getAttribute(attr);

        if (!current) return;

        var exact = attr === 'value';
        var output = replaceByPairs(current, pairs, exact);

        if (output !== current) {
          el.setAttribute(attr, output);
        }
      });
    }

    var buttons = root.querySelectorAll('button[type="submit"], button');

    for (i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var text = (btn.textContent || '').replace(/\s+/g, ' ').trim();

      if (!text) continue;

      var btnOutput = replaceByPairs(text, pairs, true);

      if (btnOutput !== text) {
        btn.textContent = btnOutput;
      }
    }
  }

  function translateSelectOptions(root, pairs, locale) {
    if (!root || !root.querySelectorAll) return;

    var fixes = locale && OPTION_LABEL_FIXES[locale] ? OPTION_LABEL_FIXES[locale] : null;
    var options = root.querySelectorAll('option');

    for (var i = 0; i < options.length; i++) {
      var option = options[i];
      var value = option.getAttribute('value') || '';
      var text = (option.textContent || '').replace(/\s+/g, ' ').trim();

      if (!text && !value) continue;

      if (fixes && applyHubspotOptionLabelFix(option, value, text, fixes)) {
        continue;
      }

      var output = replaceByPairs(text, pairs, true);

      if (output !== text) {
        option.textContent = output;
      }
    }
  }

  function isCorruptedPressOptionLabel(text, value) {
    if (value === 'Press') return true;

    if (!text) return false;

    return /^Presse+$/i.test(text) || /^Press+e+$/i.test(text);
  }

  function applyHubspotOptionLabelFix(element, value, text, fixes) {
    if (!element || !fixes) return false;

    if (value && fixes[value]) {
      if (element.textContent !== fixes[value]) {
        element.textContent = fixes[value];
      }

      return true;
    }

    if (fixes['Press'] && isCorruptedPressOptionLabel(text, value)) {
      if (element.textContent !== fixes['Press']) {
        element.textContent = fixes['Press'];
      }

      return true;
    }

    if (text && fixes[text]) {
      if (element.textContent !== fixes[text]) {
        element.textContent = fixes[text];
      }

      return true;
    }

    return false;
  }

  function fixKnownHubspotOptionLabels(root, locale) {
    if (!root || !root.querySelectorAll || !locale) return;

    var fixes = OPTION_LABEL_FIXES[locale];

    if (!fixes) return;

    var options = root.querySelectorAll('option');

    for (var i = 0; i < options.length; i++) {
      var option = options[i];
      var value = option.getAttribute('value') || '';
      var text = (option.textContent || '').replace(/\s+/g, ' ').trim();

      applyHubspotOptionLabelFix(option, value, text, fixes);
    }

    var valueTargets = root.querySelectorAll('[data-value], [value]');

    for (var j = 0; j < valueTargets.length; j++) {
      var target = valueTargets[j];

      if (!target || target.tagName === 'OPTION' || target.tagName === 'SELECT') continue;

      var targetValue = target.getAttribute('data-value') || target.getAttribute('value') || '';
      var targetText = (target.textContent || '').replace(/\s+/g, ' ').trim();

      if (!targetValue || !fixes[targetValue]) continue;

      applyHubspotOptionLabelFix(target, targetValue, targetText, fixes);
    }
  }

  var FALLBACK_ISO_REGION_CODES = 'AD,AE,AF,AG,AI,AL,AM,AO,AQ,AR,AS,AT,AU,AW,AX,AZ,BA,BB,BD,BE,BF,BG,BH,BI,BJ,BL,BM,BN,BO,BQ,BR,BS,BT,BV,BW,BY,BZ,CA,CC,CD,CF,CG,CH,CI,CK,CL,CM,CN,CO,CR,CU,CV,CW,CX,CY,CZ,DE,DJ,DK,DM,DO,DZ,EC,EE,EG,EH,ER,ES,ET,FI,FJ,FK,FM,FO,FR,GA,GB,GD,GE,GF,GG,GH,GI,GL,GM,GN,GP,GQ,GR,GS,GT,GU,GW,GY,HK,HM,HN,HR,HT,HU,ID,IE,IL,IM,IN,IO,IQ,IR,IS,IT,JE,JM,JO,JP,KE,KG,KH,KI,KM,KN,KP,KR,KW,KY,KZ,LA,LB,LC,LI,LK,LR,LS,LT,LU,LV,LY,MA,MC,MD,ME,MF,MG,MH,MK,ML,MM,MN,MO,MP,MQ,MR,MS,MT,MU,MV,MW,MX,MY,MZ,NA,NC,NE,NF,NG,NI,NL,NO,NP,NR,NU,NZ,OM,PA,PE,PF,PG,PH,PK,PL,PM,PN,PR,PS,PT,PW,PY,QA,RE,RO,RS,RU,RW,SA,SB,SC,SD,SE,SG,SH,SI,SJ,SK,SL,SM,SN,SO,SR,SS,ST,SV,SX,SY,SZ,TC,TD,TF,TG,TH,TJ,TK,TL,TM,TN,TO,TR,TT,TV,TW,TZ,UA,UG,UM,US,UY,UZ,VA,VC,VE,VG,VI,VN,VU,WF,WS,XK,YE,YT,ZA,ZM,ZW'.split(',');

  function getRegionCodeList() {
    if (typeof Intl !== 'undefined' && typeof Intl.supportedValuesOf === 'function') {
      try {
        return Intl.supportedValuesOf('region');
      } catch (e) {}
    }

    return FALLBACK_ISO_REGION_CODES;
  }

  function marketLocaleToBcp47(locale) {
    if (!locale) return 'en-US';

    var parts = String(locale).toLowerCase().split('-');

    if (parts.length !== 2) return locale;

    return parts[0] + '-' + parts[1].toUpperCase();
  }

  function translateCountryDropdownOptions(root, locale) {
    if (!root || !root.querySelectorAll) return;
    if (typeof Intl === 'undefined' || typeof Intl.DisplayNames !== 'function') return;

    var targetDisplayNames;
    var englishDisplayNames;

    try {
      targetDisplayNames = new Intl.DisplayNames([marketLocaleToBcp47(locale)], { type: 'region' });
      englishDisplayNames = new Intl.DisplayNames(['en'], { type: 'region' });
    } catch (e) {
      return;
    }

    var codes = getRegionCodeList();

    function resolveCountryCode(value, text) {
      var val = (value || '').trim();
      var label = (text || '').trim() || val;

      if (!label) return null;

      if (/^[a-z]{2}$/i.test(val)) {
        var upper = val.toUpperCase();

        if (upper === 'UK') upper = 'GB';

        return upper;
      }

      for (var i = 0; i < codes.length; i++) {
        var code = codes[i];

        try {
          if (englishDisplayNames.of(code) === label) return code;
        } catch (e) {}
      }

      for (i = 0; i < codes.length; i++) {
        code = codes[i];

        try {
          if (String(englishDisplayNames.of(code)).toLowerCase() === label.toLowerCase()) return code;
        } catch (e2) {}
      }

      return null;
    }

    function isCountrySelect(select) {
      var blob = ((select.name || '') + ' ' + (select.id || '') + ' ' + (select.className || '')).toLowerCase();

      if (/contact_testing|country|region|nation|0-\d+\/country/.test(blob)) return true;

      var field = select.closest ? select.closest('.hs-form-field') : null;

      if (field) {
        var label = field.querySelector('label');

        if (label && /country|region|land|pays|країн|nation|kraj/i.test(label.textContent)) {
          return true;
        }
      }

      var options = select.querySelectorAll('option');

      return options.length >= 15;
    }

    var selects = root.querySelectorAll('select');

    for (var s = 0; s < selects.length; s++) {
      var select = selects[s];

      if (!isCountrySelect(select)) continue;

      var options = select.querySelectorAll('option');

      for (var o = 0; o < options.length; o++) {
        var option = options[o];
        var text = (option.textContent || '').replace(/\s+/g, ' ').trim();

        if (!text) continue;
        if (/please select|bitte ausw|veuillez|оберіть/i.test(text)) continue;

        var code = resolveCountryCode(option.getAttribute('value') || '', text);

        if (!code) continue;

        try {
          var localized = targetDisplayNames.of(code);

          if (localized) {
            option.textContent = localized;
          }
        } catch (e3) {}
      }
    }
  }

  function applyLocaleToFormRoot(formRoot, locale) {
    if (!formRoot || !locale || !TRANSLATION_PAIRS[locale]) return;

    var pairs = TRANSLATION_PAIRS[locale];

    translateTextNodes(formRoot, pairs);
    translateLabelSpans(formRoot, pairs);
    translateRichTextBlocks(formRoot, pairs);
    translateFormAnchors(formRoot, pairs);
    fixLinkAdjacentSpacing(formRoot);
    translateInputsAndButtons(formRoot, pairs);
    translateSelectOptions(formRoot, pairs, locale);
    translateCountryDropdownOptions(formRoot, locale);
    fixKnownHubspotOptionLabels(formRoot, locale);
  }

  function keepAliveFormTranslation(formRoot, locale) {
    if (!formRoot || !locale || !TRANSLATION_PAIRS[locale]) return;

    if (formRoot._epropelledHsI18nTimer) return;

    var counter = 0;

    formRoot._epropelledHsI18nTimer = setInterval(function () {
      if (!formRoot.isConnected) {
        clearInterval(formRoot._epropelledHsI18nTimer);
        formRoot._epropelledHsI18nTimer = null;
        return;
      }

      applyLocaleToFormRoot(formRoot, locale);

      counter++;

      if (counter > 1200) {
        clearInterval(formRoot._epropelledHsI18nTimer);
        formRoot._epropelledHsI18nTimer = null;
      }
    }, 200);
  }

  function getHubspotTranslationRoots() {
    var roots = [];
    var seen = [];

    function addRoot(el) {
      if (!el || el.nodeType !== 1 || seen.indexOf(el) !== -1) return;
      seen.push(el);
      roots.push(el);
    }

    var forms = getAllHubspotForms();
    var i;

    for (i = 0; i < forms.length; i++) {
      addRoot(forms[i]);
      if (forms[i].closest) {
        addRoot(forms[i].closest('.hbspt-form'));
        addRoot(forms[i].closest('[data-hs-forms-root="true"]'));
      }
    }

    var embeds = document.querySelectorAll('.hbspt-form, [data-hs-forms-root="true"]');
    for (i = 0; i < embeds.length; i++) {
      addRoot(embeds[i]);
    }

    var iframes = document.querySelectorAll(
      'iframe.hs-form-iframe, iframe[id^="hs-form-iframe"], .hbspt-form iframe'
    );
    for (i = 0; i < iframes.length; i++) {
      try {
        var doc =
          iframes[i].contentDocument ||
          (iframes[i].contentWindow && iframes[i].contentWindow.document);
        if (doc && doc.body) {
          addRoot(doc.body);
        }
      } catch (e) {}
    }

    return roots;
  }

  function getDatasheetPopupRoots() {
    var roots = [];
    var seen = [];
    var selectors = [
      '#datasheetPopupOverlay',
      '#datasheetPopup',
      '.datasheet-popup-content',
      '#datasheet-form-container',
      '#hubspot-datasheet-form',
      '.datasheet-thanks-msg'
    ];
    var i;
    var nodes;

    function addRoot(el) {
      if (!el || el.nodeType !== 1 || seen.indexOf(el) !== -1) return;
      seen.push(el);
      roots.push(el);
    }

    for (i = 0; i < selectors.length; i++) {
      nodes = document.querySelectorAll(selectors[i]);

      for (var j = 0; j < nodes.length; j++) {
        addRoot(nodes[j]);
      }
    }

    return roots;
  }

  function translateDatasheetPopupMessages(locale) {
    if (!locale || !TRANSLATION_PAIRS[locale]) return;

    var pairs = TRANSLATION_PAIRS[locale];
    var popupRoots = getDatasheetPopupRoots();
    var pi;

    for (pi = 0; pi < popupRoots.length; pi++) {
      var popupRoot = popupRoots[pi];

      if (!popupRoot || !popupRoot.querySelectorAll) continue;

      translateTextNodes(popupRoot, pairs);
      translateLabelSpans(popupRoot, pairs);
      translateRichTextBlocks(popupRoot, pairs);
      translateFormAnchors(popupRoot, pairs);
      fixLinkAdjacentSpacing(popupRoot);

      var successBlocks = popupRoot.querySelectorAll(
        '.submitted-message, .hs-form__thank-you-message, [class*="submitted-message"], .hs_cos_wrapper_type_form'
      );
      var si;

      for (si = 0; si < successBlocks.length; si++) {
        translateTextNodes(successBlocks[si], pairs);
        translateLabelSpans(successBlocks[si], pairs);
        translateRichTextBlocks(successBlocks[si], pairs);
      }

      var iframes = popupRoot.querySelectorAll ? popupRoot.querySelectorAll('iframe') : [];

      for (var fi = 0; fi < iframes.length; fi++) {
        try {
          var iframeDoc =
            iframes[fi].contentDocument ||
            (iframes[fi].contentWindow && iframes[fi].contentWindow.document);

          if (!iframeDoc || !iframeDoc.body) continue;

          translateTextNodes(iframeDoc.body, pairs);
          translateLabelSpans(iframeDoc.body, pairs);
          translateRichTextBlocks(iframeDoc.body, pairs);

          var iframeSuccess = iframeDoc.body.querySelectorAll(
            '.submitted-message, .hs-form__thank-you-message, [class*="submitted-message"]'
          );

          for (var isi = 0; isi < iframeSuccess.length; isi++) {
            translateTextNodes(iframeSuccess[isi], pairs);
            translateLabelSpans(iframeSuccess[isi], pairs);
            translateRichTextBlocks(iframeSuccess[isi], pairs);
          }
        } catch (e) {}
      }
    }
  }

  function translateHubspotSuccessMessages(locale) {
    if (!locale || !TRANSLATION_PAIRS[locale]) return;

    var pairs = TRANSLATION_PAIRS[locale];
    var roots = getHubspotTranslationRoots();
    var ri;

    translateDatasheetPopupMessages(locale);

    for (ri = 0; ri < roots.length; ri++) {
      var root = roots[ri];
      if (!root || !root.querySelectorAll) continue;

      var successBlocks = root.querySelectorAll(
        '.submitted-message, .hs-form__thank-you-message, [class*="submitted-message"], .hs_cos_wrapper_type_form'
      );
      var si;

      for (si = 0; si < successBlocks.length; si++) {
        translateTextNodes(successBlocks[si], pairs);
        translateLabelSpans(successBlocks[si], pairs);
        translateRichTextBlocks(successBlocks[si], pairs);
      }

      translateTextNodes(root, pairs);
      translateRichTextBlocks(root, pairs);
    }
  }

  var datasheetPopupWatchStarted = false;

  function watchDatasheetPopupOpens() {
    if (datasheetPopupWatchStarted) return;

    datasheetPopupWatchStarted = true;

    document.addEventListener('click', function (event) {
      var target = event.target;

      if (!target || !target.closest) return;

      var btn = target.closest('[data-sheet-btn]');

      if (!btn) return;

      function tick() {
        translateDatasheetPopupMessages(getCurrentFormLocale());
        translateHubspotSuccessMessages(getCurrentFormLocale());
        refreshHubspotI18n();
      }

      tick();
      [50, 150, 300, 600, 1200, 2500].forEach(function (ms) {
        setTimeout(tick, ms);
      });
    }, true);
  }

  function scheduleSuccessMessageI18n() {
    var locale = getCurrentFormLocale();
    if (!locale || !TRANSLATION_PAIRS[locale]) return;

    function tick() {
      translateHubspotSuccessMessages(locale);
      refreshHubspotI18n();
    }

    tick();
    [100, 250, 500, 1000, 1800, 3000, 5000, 8000].forEach(function (ms) {
      setTimeout(tick, ms);
    });
  }

  function applyLocaleToAllHubspotForms(locale) {
    if (!locale || !TRANSLATION_PAIRS[locale]) return;

    var targets = collectHubspotI18nTargets();

    for (var i = 0; i < targets.length; i++) {
      applyLocaleToFormRoot(targets[i], locale);
      keepAliveFormTranslation(targets[i], locale);
    }

    translateHubspotSuccessMessages(locale);
    translateDatasheetPopupMessages(locale);
  }

  function refreshHubspotI18n() {
    var locale = getCurrentFormLocale();

    if (!locale || !TRANSLATION_PAIRS[locale]) return;

    applyLocaleToAllHubspotForms(locale);
  }

  var observerStarted = false;

  function watchHubspotForms() {
    if (observerStarted) return;

    var locale = getCurrentFormLocale();

    if (!locale || !TRANSLATION_PAIRS[locale]) return;

    observerStarted = true;

    var root = document.body || document.documentElement;
    var debounceTimer = null;
    var count = 0;

    var observer = new MutationObserver(function () {
      count++;

      if (count > 5000) return;

      clearTimeout(debounceTimer);

      debounceTimer = setTimeout(function () {
        refreshHubspotI18n();
      }, 150);
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function scheduleI18n(formArg) {
    var locale = getCurrentFormLocale();

    if (!locale || !TRANSLATION_PAIRS[locale]) return;

    function tick() {
      var root = normalizeHubspotArg(formArg);

      if (root) {
        root = resolveHubspotI18nRoot(root);
        applyLocaleToFormRoot(root, locale);
        keepAliveFormTranslation(root, locale);
      }

      refreshHubspotI18n();
    }

    tick();

    [100, 250, 500, 1000, 1800, 3000].forEach(function (ms) {
      setTimeout(tick, ms);
    });
  }

  function getValueFromSubmission(submissionValues, name) {
    if (!submissionValues) return '';

    if (Array.isArray(submissionValues)) {
      for (var i = 0; i < submissionValues.length; i++) {
        var field = submissionValues[i];

        if (field && field.name === name) {
          return field.value != null ? String(field.value) : '';
        }
      }

      return '';
    }

    return submissionValues[name] != null ? String(submissionValues[name]) : '';
  }

  window.getDatasheetFormData = function (submissionValues) {
    if (!submissionValues) return null;

    return {
      firstName: getValueFromSubmission(submissionValues, 'firstname'),
      lastName: getValueFromSubmission(submissionValues, 'lastname'),
      email: getValueFromSubmission(submissionValues, 'email'),
      phone: getValueFromSubmission(submissionValues, 'phone'),
      company: getValueFromSubmission(submissionValues, 'company'),
      country: getValueFromSubmission(submissionValues, 'contact_testing'),
      datasheetName: getValueFromSubmission(submissionValues, 'datasheet_name')
    };
  };

  function finalizePageLanguageTag(tag) {
    if (!tag || typeof tag !== 'string') return '';

    var normalized = String(tag).trim().replace(/_/g, '-');

    if (normalizeLocaleToken(normalized) === 'uk') return 'uk-ua';

    return normalized;
  }

  function getCurrentPageLanguageForPayload() {
    var englishMarket = getEnglishMarketLocale();

    if (englishMarket) return englishMarket;

    var locale = getCurrentFormLocale();

    if (locale) return finalizePageLanguageTag(locale);

    var htmlLang = document.documentElement && document.documentElement.lang;

    if (htmlLang) return finalizePageLanguageTag(htmlLang);

    if (window.__EP_HUBSPOT_I18N_LOCALE) {
      return finalizePageLanguageTag(window.__EP_HUBSPOT_I18N_LOCALE);
    }

    if (window.Shopify && window.Shopify.locale) {
      return finalizePageLanguageTag(String(window.Shopify.locale));
    }

    if (navigator.language) {
      return finalizePageLanguageTag(navigator.language);
    }

    return '';
  }

  function sendThankYouEmail(payload) {
    if (!payload || !payload.email) return;

    var typeElement = document.querySelector('.popup_header_content');
    var typeValue = typeElement ? typeElement.innerText.trim() : '';

    fetch(DATASHEET_EMAIL_API, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        type: typeValue,
        firstName: payload.firstName,
        lastName: payload.lastName,
        email: payload.email,
        phone: payload.phone,
        country: payload.country,
        tags: payload.datasheetName || '',
        note: 'Company: ' + (payload.company || ''),
        pageLanguage: getCurrentPageLanguageForPayload()
      })
    })
      .then(function (res) {
        return res.json();
      })
      .catch(function () {});
  }

  function patchHubspotFormsCreate() {
    if (
      typeof window.hbspt === 'undefined' ||
      !window.hbspt.forms ||
      typeof window.hbspt.forms.create !== 'function'
    ) {
      return;
    }

    var currentCreate = window.hbspt.forms.create;

    if (currentCreate._epropelledHbi18nWrap === true) return;

    var originalCreate = currentCreate;

    var wrappedCreate = function (options) {
      if (!options) return originalCreate.call(this, options);

      var formId = normalizeFormId(options.formId);
      var datasheetId = normalizeFormId(DATASHEET_FORM_ID);
      var contactId = normalizeFormId(CONTACT_SALES_FORM_ID);

      var isDatasheet = formId === datasheetId;
      var isContactSales = formId === contactId;
      var shouldHandleI18n = isDatasheet || isContactSales;

      var locale = getCurrentFormLocale();

      if (shouldHandleI18n && locale && TRANSLATION_PAIRS[locale]) {
        if (!options.locale) {
          options.locale = locale;
        }

        if (!options.language) {
          options.language = locale.split('-')[0];
        }
      }

      var userReady = options.onFormReady;
      var userBefore = options.onBeforeFormSubmit;
      var userSubmitted = options.onFormSubmitted;

      options.onFormReady = function ($form) {
        if (userReady) {
          try {
            userReady.apply(this, arguments);
          } catch (e) {}
        }

        if (shouldHandleI18n) {
          scheduleI18n($form);
          watchHubspotForms();
          refreshHubspotI18n();
        }
      };

      if (isDatasheet) {
        options.onBeforeFormSubmit = function ($form, submissionValues) {
          if (userBefore) {
            try {
              userBefore($form, submissionValues);
            } catch (e) {}
          }

          lastSubmissionForEmail = window.getDatasheetFormData(submissionValues);
        };

        options.onFormSubmitted = function () {
          if (lastSubmissionForEmail) {
            sendThankYouEmail(lastSubmissionForEmail);
            lastSubmissionForEmail = null;
          }

          scheduleSuccessMessageI18n();

          if (userSubmitted) {
            try {
              userSubmitted.apply(this, arguments);
            } catch (e) {}
          }
        };
      }

      if (shouldHandleI18n && isContactSales) {
        options.onFormSubmitted = function () {
          scheduleSuccessMessageI18n();

          if (userSubmitted) {
            try {
              userSubmitted.apply(this, arguments);
            } catch (e) {}
          }
        };
      }

      return originalCreate.call(this, options);
    };

    wrappedCreate._epropelledHbi18nWrap = true;

    window.hbspt.forms.create = wrappedCreate;
  }

  function initHubspotI18n() {
    patchHubspotFormsCreate();
    refreshHubspotI18n();
    watchHubspotForms();
    watchDatasheetPopupOpens();

    [100, 300, 600, 1200, 2500, 5000].forEach(function (ms) {
      setTimeout(function () {
        patchHubspotFormsCreate();
        refreshHubspotI18n();
        watchHubspotForms();
      }, ms);
    });
  }

  window.addEventListener('message', function (event) {
    var data = event.data;

    if (!data || data.type !== 'hsFormCallback') return;

    var formId = normalizeFormId(data.id || data.formId);
    var datasheetId = normalizeFormId(DATASHEET_FORM_ID);
    var contactId = normalizeFormId(CONTACT_SALES_FORM_ID);

    if (!formId || (formId !== datasheetId && formId !== contactId)) return;

    if (data.eventName === 'onFormReady') {
      refreshHubspotI18n();

      [100, 250, 500, 1200, 2500].forEach(function (ms) {
        setTimeout(refreshHubspotI18n, ms);
      });
    }

    if (data.eventName === 'onFormSubmitted') {
      scheduleSuccessMessageI18n();
    }

    if (data.eventName === 'onFormSubmitted' && formId === contactId) {
      if (window.__contactSalesSubmitted) return;

      window.__contactSalesSubmitted = true;

      var submissionValues =
        data.data && data.data.submissionValues
          ? data.data.submissionValues
          : {};

      var payload = {
        type: 'sale_form',
        firstName: getValueFromSubmission(submissionValues, 'firstname'),
        lastName: getValueFromSubmission(submissionValues, 'lastname'),
        email: getValueFromSubmission(submissionValues, 'email'),
        phone: getValueFromSubmission(submissionValues, 'phone'),
        company: getValueFromSubmission(submissionValues, 'company'),
        country: getValueFromSubmission(submissionValues, 'contact_testing'),
        message: getValueFromSubmission(submissionValues, 'message'),
        pageUrl: window.location.href,
        submittedAt: new Date().toISOString(),
        pageLanguage: getCurrentPageLanguageForPayload()
      };

      fetch(DATASHEET_EMAIL_API, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          return res.json();
        })
        .catch(function () {});
    }
  });

  window.addEventListener('hs-form-event:on-ready', function () {
    refreshHubspotI18n();

    [100, 400, 1000, 2200].forEach(function (ms) {
      setTimeout(refreshHubspotI18n, ms);
    });
  });

  window.addEventListener('load', function () {
    refreshHubspotI18n();

    [100, 600, 2000, 4000].forEach(function (ms) {
      setTimeout(refreshHubspotI18n, ms);
    });
  });

  patchHubspotFormsCreate();

  var quickPatchCounter = 0;
  var quickPatchTimer = setInterval(function () {
    patchHubspotFormsCreate();

    quickPatchCounter++;

    if (quickPatchCounter > 120) {
      clearInterval(quickPatchTimer);
    }
  }, 10);

  var slowPatchCounter = 0;
  var slowPatchTimer = setInterval(function () {
    patchHubspotFormsCreate();
    refreshHubspotI18n();

    slowPatchCounter++;

    if (slowPatchCounter > 40) {
      clearInterval(slowPatchTimer);
    }
  }, 400);

  var pollCounter = 0;
  var pollTimer = setInterval(function () {
    refreshHubspotI18n();

    pollCounter++;

    if (pollCounter > 400) {
      clearInterval(pollTimer);
    }
  }, 400);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHubspotI18n);
  } else {
    initHubspotI18n();
  }

  window.__epropelledRefreshHubspotI18n = refreshHubspotI18n;
  window.__epropelledHubspotFormTranslationLocale = getCurrentFormLocale;
  window.__epropelledGetPageLanguageForPayload = getCurrentPageLanguageForPayload;
  window.__epropelledTranslateHubspotSuccessMessages = scheduleSuccessMessageI18n;
})();

//set country defalut
(function () {
  var COUNTRY_FIELD_NAME = 'contact_testing';
  var GEO_API_URL = 'https://ipapi.co/json/';

  var COUNTRY_CODE_TO_HUBSPOT_VALUE = {
    AF: 'Afghanistan',
    AL: 'Albania',
    DZ: 'Algeria',
    AD: 'Andorra',
    AO: 'Angola',
    AG: 'Antigua and Barbuda',
    AR: 'Argentina',
    AM: 'Armenia',
    AU: 'Australia',
    AT: 'Austria',
    AZ: 'Azerbaijan',
    BS: 'Bahamas',
    BH: 'Bahrain',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Belarus',
    BE: 'Belgium',
    BZ: 'Belize',
    BJ: 'Benin',
    BT: 'Bhutan',
    BO: 'Bolivia',
    BA: 'Bosnia and Herzegovina',
    BW: 'Botswana',
    BR: 'Brazil',
    BN: 'Brunei',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    CV: 'Cabo Verde',
    KH: 'Cambodia',
    CM: 'Cameroon',
    CA: 'Canada',
    CF: 'Central African Republic',
    TD: 'Chad',
    CL: 'Chile',
    CN: 'China',
    CO: 'Colombia',
    KM: 'Comoros',
    CG: 'Congo (Congo-Brazzaville)',
    CR: 'Costa Rica',
    HR: 'Croatia',
    CU: 'Cuba',
    CY: 'Cyprus',
    CZ: 'Czech Republic',
    CD: 'Democratic Republic of the Congo',
    DK: 'Denmark',
    DJ: 'Djibouti',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    EC: 'Ecuador',
    EG: 'Egypt',
    SV: 'El Salvador',
    GQ: 'Equatorial Guinea',
    ER: 'Eritrea',
    EE: 'Estonia',
    SZ: 'Eswatini',
    ET: 'Ethiopia',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'France',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Georgia',
    DE: 'Germany',
    GH: 'Ghana',
    GR: 'Greece',
    GD: 'Grenada',
    GT: 'Guatemala',
    GN: 'Guinea',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HT: 'Haiti',
    HN: 'Honduras',
    HU: 'Hungary',
    IS: 'Iceland',
    IN: 'India',
    ID: 'Indonesia',
    IR: 'Iran',
    IQ: 'Iraq',
    IE: 'Ireland',
    IL: 'Israel',
    IT: 'Italy',
    JM: 'Jamaica',
    JP: 'Japan',
    JO: 'Jordan',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KW: 'Kuwait',
    KG: 'Kyrgyzstan',
    LA: 'Laos',
    LV: 'Latvia',
    LB: 'Lebanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libya',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MG: 'Madagascar',
    MW: 'Malawi',
    MY: 'Malaysia',
    MV: 'Maldives',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Marshall Islands',
    MR: 'Mauritania',
    MU: 'Mauritius',
    MX: 'Mexico',
    FM: 'Micronesia',
    MD: 'Moldova',
    MC: 'Monaco',
    MN: 'Mongolia',
    ME: 'Montenegro',
    MA: 'Morocco',
    MZ: 'Mozambique',
    MM: 'Myanmar',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Netherlands',
    NZ: 'New Zealand',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    KP: 'North Korea',
    MK: 'North Macedonia',
    NO: 'Norway',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PS: 'Palestine State',
    PA: 'Panama',
    PG: 'Papua New Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Philippines',
    PL: 'Poland',
    PT: 'Portugal',
    QA: 'Qatar',
    RO: 'Romania',
    RU: 'Russia',
    RW: 'Rwanda',
    KN: 'Saint Kitts and Nevis',
    LC: 'Saint Lucia',
    VC: 'Saint Vincent and the Grenadines',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'Sao Tome and Principe',
    SA: 'Saudi Arabia',
    SN: 'Senegal',
    RS: 'Serbia',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SK: 'Slovakia',
    SI: 'Slovenia',
    SB: 'Solomon Islands',
    SO: 'Somalia',
    ZA: 'South Africa',
    KR: 'South Korea',
    SS: 'South Sudan',
    ES: 'Spain',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SR: 'Suriname',
    SE: 'Sweden',
    CH: 'Switzerland',
    SY: 'Syria',
    TW: 'Taiwan',
    TJ: 'Tajikistan',
    TZ: 'Tanzania',
    TH: 'Thailand',
    TL: 'Timor-Leste',
    TG: 'Togo',
    TO: 'Tonga',
    TT: 'Trinidad and Tobago',
    TN: 'Tunisia',
    TR: 'Turkey',
    TM: 'Turkmenistan',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ukraine',
    AE: 'United Arab Emirates',
    GB: 'United Kingdom',
    US: 'United States',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VU: 'Vanuatu',
    VA: 'Vatican City',
    VE: 'Venezuela',
    VN: 'Vietnam',
    YE: 'Yemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe'
  };

  function normalize(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function triggerEvents(el) {
    ['input', 'change', 'blur'].forEach(function (eventName) {
      el.dispatchEvent(new Event(eventName, {
        bubbles: true,
        cancelable: true
      }));
    });

    if (window.jQuery) {
      try {
        window.jQuery(el).trigger('input').trigger('change').trigger('blur');
      } catch (e) {}
    }
  }

  function setNativeSelectValue(select, value) {
    var descriptor = Object.getOwnPropertyDescriptor(
      window.HTMLSelectElement.prototype,
      'value'
    );

    if (descriptor && descriptor.set) {
      descriptor.set.call(select, value);
    } else {
      select.value = value;
    }
  }

  function getAllDocuments() {
    var docs = [document];

    var iframes = document.querySelectorAll('iframe');

    for (var i = 0; i < iframes.length; i++) {
      try {
        var iframeDoc =
          iframes[i].contentDocument ||
          (iframes[i].contentWindow && iframes[i].contentWindow.document);

        if (iframeDoc) docs.push(iframeDoc);
      } catch (e) {}
    }

    return docs;
  }

  function collectShadowSelects(root, output) {
    if (!root || !root.querySelectorAll) return;

    var all = root.querySelectorAll('*');

    for (var i = 0; i < all.length; i++) {
      var el = all[i];

      if (!el.shadowRoot) continue;

      var selects = el.shadowRoot.querySelectorAll('select[name="' + COUNTRY_FIELD_NAME + '"]');

      for (var j = 0; j < selects.length; j++) {
        output.push(selects[j]);
      }

      collectShadowSelects(el.shadowRoot, output);
    }
  }

  function getCountrySelects() {
    var output = [];
    var docs = getAllDocuments();

    for (var i = 0; i < docs.length; i++) {
      var selects = docs[i].querySelectorAll('select[name="' + COUNTRY_FIELD_NAME + '"]');

      for (var j = 0; j < selects.length; j++) {
        output.push(selects[j]);
      }

      collectShadowSelects(docs[i].documentElement, output);
    }

    return output;
  }

  function findOption(select, hubspotCountryValue, countryCode) {
    var options = select.querySelectorAll('option');
    var code = normalize(countryCode);
    var country = normalize(hubspotCountryValue);

    for (var i = 0; i < options.length; i++) {
      var option = options[i];
      var value = option.getAttribute('value') || '';
      var text = option.textContent || '';

      if (
        normalize(value) === country ||
        normalize(text) === country ||
        normalize(value) === code ||
        normalize(text) === code
      ) {
        return {
          option: option,
          index: i,
          value: value
        };
      }
    }

    return null;
  }

  function removeErrors(select) {
    select.classList.remove('invalid', 'error', 'is-placeholder');
    select.removeAttribute('aria-invalid');

    var field = select.closest ? select.closest('.hs-form-field') : null;

    if (field) {
      field.classList.remove('invalid', 'error');

      var errorLists = field.querySelectorAll('.hs-error-msgs, .hs-error-msg');

      for (var i = 0; i < errorLists.length; i++) {
        errorLists[i].style.display = 'none';
      }
    }
  }

  function lockSelect(select) {
    /*
      Do not use disabled because HubSpot may not submit disabled fields.
    */
    select.setAttribute('data-auto-country-locked', 'true');
    select.setAttribute('aria-disabled', 'true');
    select.setAttribute('tabindex', '-1');

    select.style.pointerEvents = 'none';
    select.style.backgroundColor = '#f3f4f6';
    select.style.cursor = 'not-allowed';
    select.style.color = '#555';

    if (select.__autoCountryLocked) return;

    select.__autoCountryLocked = true;

    ['mousedown', 'click', 'keydown', 'touchstart'].forEach(function (eventName) {
      select.addEventListener(eventName, function (event) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }, true);
    });
  }

  function setCountryOnSelect(select, hubspotCountryValue, countryCode) {
    var match = findOption(select, hubspotCountryValue, countryCode);

    if (!match) {
      console.warn('HubSpot country option not found', {
        hubspotCountryValue: hubspotCountryValue,
        countryCode: countryCode,
        select: select
      });
      return false;
    }

    var options = select.querySelectorAll('option');

    for (var i = 0; i < options.length; i++) {
      options[i].selected = false;
      options[i].removeAttribute('selected');
    }

    match.option.selected = true;
    match.option.setAttribute('selected', 'selected');

    select.selectedIndex = match.index;
    setNativeSelectValue(select, match.value);
    select.value = match.value;

    removeErrors(select);
    triggerEvents(select);
    lockSelect(select);

    console.log('Country selected in HubSpot:', {
      value: select.value,
      selectedIndex: select.selectedIndex,
      visibleText: select.options[select.selectedIndex] ? select.options[select.selectedIndex].text : ''
    });

    return select.value === match.value;
  }

  function applyCountry(countryCode, countryNameFromApi) {
    var code = String(countryCode || '').toUpperCase();
    var hubspotCountryValue = COUNTRY_CODE_TO_HUBSPOT_VALUE[code] || countryNameFromApi;

    if (!hubspotCountryValue) {
      console.warn('No HubSpot country value found for:', countryCode, countryNameFromApi);
      return false;
    }

    var selects = getCountrySelects();

    if (!selects.length) {
      console.warn('HubSpot country select not found yet.');
      return false;
    }

    var success = false;

    for (var i = 0; i < selects.length; i++) {
      if (setCountryOnSelect(selects[i], hubspotCountryValue, code)) {
        success = true;
      }
    }

    return success;
  }

  function startAutoCountry(countryCode, countryName) {
    window.__EP_IP_COUNTRY = {
      code: countryCode,
      name: countryName
    };

    var attempts = 0;
    var maxAttempts = 80;

    var timer = setInterval(function () {
      attempts++;

      var success = applyCountry(countryCode, countryName);

      if (success && attempts > 5) {
        clearInterval(timer);
      }

      if (attempts >= maxAttempts) {
        clearInterval(timer);
        console.warn('Stopped trying to set HubSpot country after max attempts.');
      }
    }, 250);

    var observer = new MutationObserver(function () {
      applyCountry(countryCode, countryName);
    });

    observer.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function fetchIpCountry() {
    fetch(GEO_API_URL)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        var countryCode = data.country_code || data.countryCode || '';
        var countryName = data.country_name || data.country || '';

        console.log('Detected IP country:', {
          code: countryCode,
          name: countryName
        });

        startAutoCountry(countryCode, countryName);
      })
      .catch(function (error) {
        console.warn('IP country detection failed:', error);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchIpCountry);
  } else {
    fetchIpCountry();
  }

  /*
    Manual testing:
    window.__setHubSpotCountry('IN')
    window.__setHubSpotCountry('FR')
    window.__setHubSpotCountry('US')
  */
  window.__setHubSpotCountry = function (countryCode, countryName) {
    return applyCountry(countryCode, countryName);
  };
})();
